export default "__VITE_ASSET__6444c7aa__"